import React, { useContext, useState } from 'react'
import { useEffect } from 'react'
import { getTeamGoal, Goal } from '../../service/PerformanceAPI'
import EmployeeBlock from './EmployeeBlock'
import { UserContext } from '../../constant';
import { encryptStorage } from '../../constant'

export default function OrganizationSub({ role, evaluationShow, team, forCount, evaluationId }) {

    const user = useContext(UserContext)


    let details = { role: '', roleId: '', week: 0, domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [individualGoal, SetIndividualGoal] = useState([]);
    const [EvaluationId, setEvaluationId] = useState();
    const [AllProgress, setAllProgress] = useState([]);
    const [teamGoal, SetTeamGoal] = useState([]);

    useEffect(() => {
        
        if (user?.teamGoal) {
            
            SetTeamGoal(user?.teamGoal);
            if (user?.AllProgress) setAllProgress(user?.AllProgress)
        }
    }, [user?.AllProgress, user?.teamGoal])

    useEffect(() => {
       
        userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');
        if (evaluationId) setEvaluationId(evaluationId);

        // if (customStartEvaluation) setcustomStartEvaluation(props.customStartEvaluation)
        // if (Object.keys(props.evaluationShow).length > 0) setEvaluationShow(props.evaluationShow);

    }, [evaluationId]);

    const loadData = async () => {
        let goalData = {
            role: 'Hr Manager',
            employeeId: userDetails.roleId,
            // evaluation_period_id: props.evaluationPeriodId,
            evaluation_period_id: EvaluationId,
            domain: userDetails.domain,
            organizationDomain: '',
        };
        if (EvaluationId) {
            let result = await Goal(goalData);
            // setDomain(result.data.ResponseData)
        }
    };

    const IndividualClicked = async (domainName) => {
        let goalData = {
            // role: 'Hr Manager',
            role: role ? 'Manager' : 'Hr Manager',
            employeeId: userDetails.roleId,
            // evaluation_period_id: props.evaluationPeriodId,
            evaluation_period_id: EvaluationId,
            domain: userDetails.domain,
            organizationDomain: domainName,
        };

        let result = await Goal(goalData);
        SetIndividualGoal(result.data.ResponseData);
    };

    const TeamGoalClicked = async (domain) => {
       
        let goalData;
        role == 'Manager' ? goalData = {
            team: domain,
            evaluation_period_id: EvaluationId,
            empId: userDetails.roleId
        } : goalData = {
            team: domain,
            evaluation_period_id: EvaluationId,
        }
        // let goalData = {
        //     team: domain,
        //     // evaluation_period_id: props.evaluationPeriodId,
        //     evaluation_period_id: EvaluationId,
        // };
        let result = await getTeamGoal(goalData);
        if (result.data.ResponseData !== null) {

            SetTeamGoal(result.data.ResponseData);
            setAllProgress(result.data.AllProgress);
        }
    };

    return (
        <div id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}main` : "uxdmain"} className={role == 'Manager' ? `accordion-collapse collapse show` : `accordion-collapse collapse`} aria-labelledby={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}` : "uxd"} data-bs-parent="#accordionExample">
            <div className={role == 'Manager' ? "accordion-body mx-2 px-0 py-0" : "accordion-body mx-2 py-0"}>
                <div className="accordion" id="accordionPanelsStayOpenExample">
                    <div className="accordion-item border-0 accordian-table-sty">
                        <h2 className="accordion-header mb-2 px-0" id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}individualgoal` : "individualgoal"}>
                            <button
                                onClick={() => {
                                    IndividualClicked(team);
                                }}
                                className="accordion-button-custom collapsed border-0 bg-transparent pb-3 bold-text font-15" type="button" data-bs-toggle="collapse" data-bs-target={team ? `#${team.replaceAll(' ', '')?.replaceAll('&', '')}individualgoalmain` : "#individualgoalmain"} aria-expanded="false" aria-controls={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}individualgoalmain` : "individualgoalmain"}>
                                Individual Goal {role == 'Manager' ? null : `(${forCount?.individualCount})`}
                            </button>
                        </h2>
                        <div id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}individualgoalmain` : "individualgoalmain"} className={`accordion-collapse collapse `} aria-labelledby={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}individualgoal` : "individualgoal"}>
                            <div className="accordion-body p-0">
                                <div className="accordion" id="accordionPanelsStayOpenExample">
                                    {individualGoal?.map(((res, i) => {
                                        return (
                                            <EmployeeBlock role={role} type={'individual'} evaluationShow={evaluationShow} evaluationId={evaluationId} individualGoal={res} index={i} />
                                        )
                                    }))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="accordion-item border-0 my-2 accordian-table-sty px-0">
                    <h2 className="accordion-header mb-2 px-0" id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoal` : "teamgoal"}>
                        <button
                            onClick={() => {
                                TeamGoalClicked(team);
                            }}
                            className="accordion-button-custom collapsed border-0 bg-transparent pb-2 bold-text font-15" type="button" data-bs-toggle="collapse" data-bs-target={team ? `#${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalmain` : "#teamgoalmain"} aria-expanded="false" aria-controls={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalmain` : "teamgoalmain"} >
                            Team Goal {role == 'Manager' ? null : `(${forCount?.teamCount})`}
                        </button>
                    </h2>
                    <div id={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoalmain` : "teamgoalmain"} className={`accordion-collapse collapse  `} aria-labelledby={team ? `${team.replaceAll(' ', '')?.replaceAll('&', '')}teamgoal` : "teamgoal"}>
                        <div className="accordion-body mx-3 goal-bg-color p-0">
                            <div className="accordion" id="accordionPanelsStayOpenExample1">
                                {teamGoal?.map(((res, i) => {
                                    return (
                                        <EmployeeBlock role={role} progress={AllProgress[i]} type={'team'} team={team} evaluationShow={evaluationShow} evaluationId={evaluationId} goal={res} index={i} />
                                    )
                                }))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
